import {
  SET_LANGUAGE,
  CHANGE_LANGUAGE_REQUEST,
  CHANGE_LANGUAGE_SUCCESS,
  CHANGE_LANGUAGE_FAILURE
} from './actions';

const initialState = {
  isChanging: false,
  current: 'en',
  error: false
};

export default function languageReducer(state = initialState, action) {
  switch (action.type) {
    case SET_LANGUAGE:
      return { ...state, current: action.payload.language };
    case CHANGE_LANGUAGE_REQUEST:
      return { ...state, isChanging: true };
    case CHANGE_LANGUAGE_SUCCESS:
      return { ...state, isChanging: false, current: action.payload.language };
    case CHANGE_LANGUAGE_FAILURE:
      return { ...state, isChanging: false, error: true };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/language/reducer.js